/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_New_Job_DescInputs */

const en_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a job URL to auto-extract, or enter details manually.`)
};

const de_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine Stellen-URL zum automatischen Extrahieren ein oder gib Details manuell ein.`)
};

const fr_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colle une URL d'offre pour l'extraction automatique, ou entre les détails manuellement.`)
};

const es_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegue una URL de oferta para extracción automática, o ingrese los detalles manualmente.`)
};

const it_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un URL del lavoro per estrarre automaticamente, oppure inserisci i dettagli manualmente.`)
};

const nl_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een vacature-URL om automatisch te extraheren, of voer de details handmatig in.`)
};

const pl_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wklej URL oferty pracy, aby automatycznie wyodrębnić dane, lub wprowadź szczegóły ręcznie.`)
};

const fi_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liitä työpaikan URL hakeaksesi automaattisesti tai syötä tiedot manuaalisesti.`)
};

const da_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsæt en job-URL for at auto-udtrække, eller indtast detaljer manuelt.`)
};

const sv_jobs_new_job_desc = /** @type {(inputs: Jobs_New_Job_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klistra in en jobb-URL för att hämta automatiskt, eller ange detaljer manuellt.`)
};

/**
* | output |
* | --- |
* | "Paste a job URL to auto-extract, or enter details manually." |
*
* @param {Jobs_New_Job_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_new_job_desc = /** @type {((inputs?: Jobs_New_Job_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_New_Job_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_new_job_desc(inputs)
	if (locale === "fr") return fr_jobs_new_job_desc(inputs)
	if (locale === "es") return es_jobs_new_job_desc(inputs)
	if (locale === "it") return it_jobs_new_job_desc(inputs)
	if (locale === "nl") return nl_jobs_new_job_desc(inputs)
	if (locale === "pl") return pl_jobs_new_job_desc(inputs)
	if (locale === "fi") return fi_jobs_new_job_desc(inputs)
	if (locale === "da") return da_jobs_new_job_desc(inputs)
	if (locale === "sv") return sv_jobs_new_job_desc(inputs)
	return en_jobs_new_job_desc(inputs)
});